module.exports = __webpack_public_path__ + "assets/img/ci-contrast.bbeefde9.svg";